module.exports = __webpack_public_path__ + "img/toanchet-aceleda.69b670ff.png";